import dynamic from "next/dynamic";
import UsecasesGalleryTabsConfig from "./usecases-gallery-tabs-config";
import UsecasesGalleryTabsAdvancedConfig from "./usecases-gallery-tabs-advanced-config";
const UsecasesGalleryTabsComponent = dynamic(()=>import("./usecases-gallery-tabs-component"));
export default {
    UsecasesGalleryTabsComponent,
    UsecasesGalleryTabsConfig,
    UsecasesGalleryTabsAdvancedConfig
};
